var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"skill-tag-list-item"},[_vm._t("tag-button"),_vm._v(" "),_vm._t("dropdown-list")],2)}
var staticRenderFns = []

export { render, staticRenderFns }